var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircleSlashinline = function SvgCircleSlashinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.88c-3.668 0-6.62 2.94-6.62 6.542 0 3.603 2.952 6.543 6.62 6.543s6.62-2.94 6.62-6.543C15.62 5.82 12.669 2.88 9 2.88ZM0 9.421C0 4.484 4.04.5 9 .5s9 3.984 9 8.922c0 4.94-4.04 8.923-9 8.923S0 14.36 0 9.422Z",
    fill: "#A9A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.938 4.437-11.25 11.25-1.857-1.856 11.25-11.25 1.857 1.856Z",
    fill: "#A9A8A8"
  })));
};

export default SvgCircleSlashinline;